<box-chips *ngIf="descriptionBadges?.length">
  <box-chip *ngFor="let badge of descriptionBadges">
    <img boxChipImage [src]="badge.imageUrl" [alt]="badge.label" />
    {{ badge.label }}
  </box-chip>
</box-chips>
